import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './ProfilesAnnouncementBackgroundWrapper.module.css';

interface Props {
    gradient: boolean;
}

export const ProfilesAnnouncementBackgroundWrapper: FC<PropsWithChildren<Props>> = ({
    gradient,
    children,
}) => (
    <div
        className={classnames(styles.announcementBackground, {
            [styles.announcementBackgroundGradient]: gradient,
        })}
    >
        {children}
    </div>
);
